import axios from 'axios';
import { API_URL } from '../../../config/config';

const getStockLabel = async () => {
	const LabelTypeId = '7';
	const response = await axios.post(`${API_URL}/label/get/label`, { LabelTypeId });
	const activeLabels = response.data.Labels.filter((label) => label.IsActive);

	return activeLabels;
};

const labelService = {
	getStockLabel,
};

export default labelService;
